import React, { useEffect, useContext, useState } from 'react'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import EmployeeContext from '@/product/context/employee/empContext'
import Loaders from '@/product/components/molecules/Loaders'
import { mapData } from '@/product/common/components'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import { capitalize } from '@/custom/common/components'
import { useFormik } from 'formik'
import { Button, Menu, MenuItem, LinearProgress, AppBar } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import CustomDialog from '@/product/components/organisms/Dialog'
import * as Yup from 'yup'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import EmpPermission from './EmpPermission'
import { useTranslation } from 'react-i18next'
import Layout from '../../templates/Layout'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const EmployeeForm = (props) => {
    const employeeContext = useContext(EmployeeContext)
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const { t } = useTranslation()
    const [empPermission, setEmpPermission] = useState(false)
    const {
        single_employee,
        getSingleEmployee,
        employeeAction,
        changeUserStatus,
        responseStatus: responseStatusEmployee,
    } = employeeContext
    const data = props.data
    const [anchorEl, setAnchorEl] = useState(null)

    const formikPassword = useFormik({
        initialValues: props.passwordInitialValues,
        validationSchema: props.validationArrayPassword,
        onSubmit: (values) => {
            values.email = formik?.values?.emp_email
            employeeAction(values)
            setIsLoading(true)
        },
    })
    const formik = useFormik({
        initialValues: props.initialValues,
        validationSchema: props.validationArray,
        enableReinitialize: true,
        onSubmit: (values) => {
            setIsLoading(true)
            if (values.id === 0 && props?.custom && props?.agencyData?.id > 0) {
                values.emp_agencies = props?.agencyData?.id?.toString()
            }
            if (props.dynamicPermission) {
                if (values.emp_permissions.includes('/listing')) {
                    if (!values.emp_permissions.includes('/listing/all')) {
                        let listingarray = [
                            '/listing/all',
                            '/listing/open',
                            '/listing/sold',
                            '/listing/draft',
                            '/listing/unsold',
                            '/listing/relisted',
                            '/listing/removed',
                            '/listing/create_truckload',
                            '/listing/draft/open',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...listingarray,
                        ]
                    }
                }
                if (values.emp_permissions.includes('/auction')) {
                    if (!values.emp_permissions.includes('/auction/all')) {
                        let auctionArray = [
                            '/auction/open',
                            '/auction/upcomming',
                            '/auction/draft',
                            '/auction/closed',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...auctionArray,
                        ]
                    }
                }
                if (values.emp_permissions.includes('/buyers')) {
                    if (!values.emp_permissions.includes('/buyers/all')) {
                        let buyerarray = [
                            '/buyers/all',
                            '/buyers/active',
                            '/buyers/deactivate',
                            '/buyers/suspended',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...buyerarray,
                        ]
                    }
                }
                if (values.emp_permissions.includes('/org')) {
                    if (!values.emp_permissions.includes('/org/all')) {
                        let sellerarray = [
                            '/org/all',
                            '/org/active',
                            '/org/deactivate',
                            '/org/suspended',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...sellerarray,
                        ]
                    }
                }

                if (values.emp_permissions.includes('/invoice')) {
                    if (!values.emp_permissions.includes('/invoice/all')) {
                        let invoicearray = [
                            '/invoice/all',
                            '/invoice/customer_checkout',
                            '/invoice/unpaid',
                            '/invoice/paid',
                            '/invoice/paid/completed',
                            '/invoice/paid/not_completed',
                            '/invoice/draft',
                            '/invoice/cancel',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...invoicearray,
                        ]
                    }
                }
                if (values.emp_permissions.includes('/erp')) {
                    if (
                        !values.emp_permissions.includes('/erp') ||
                        !values.emp_permissions.includes('/erp/manifest')
                    ) {
                        let erparray = ['/erp/manifest']
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...erparray,
                        ]
                    }
                }
                if (values.emp_permissions.includes('/listing')) {
                    if (
                        !values.emp_permissions.includes('/listing') ||
                        !values.emp_permissions.includes('/listing/removed')
                    ) {
                        let erparray = ['/listing/removed']
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...erparray,
                        ]
                    }
                }

                if (values.emp_permissions.includes('/ordercontrol')) {
                    if (!values.emp_permissions.includes('/ordercontrol/all')) {
                        let ordercontrolarray = [
                            '/ordercontrol/new',
                            '/ordercontrol/undelivered',
                            '/ordercontrol/intransit',
                            '/ordercontrol/pickup',
                            '/ordercontrol/completed',
                            '/ordercontrol/cancelled',
                        ]
                        values.emp_permissions = [
                            ...values.emp_permissions,
                            ...ordercontrolarray,
                        ]
                    }
                }
                employeeAction(values)
            } else {
                employeeAction(values)
            }
            setReload(!reload)
        },
    })

    const [empModal, setEmpModal] = useState(false)
    const [empStatusModal, setEmpStatusModal] = useState(false)
    const [passwordStatus, setPasswordStatus] = useState(false)

    const statusValidation = Yup.object({
        action: Yup.string().required('Required'),
    })

    const formikStatus = useFormik({
        initialValues: {
            action: '',
            user_id: null,
        },
        validationSchema: statusValidation,
        onSubmit: (values) => {
            console.log(values, 'values.action')
            if (
                values.action === 'active' ||
                values.action === 'deactivate' ||
                values.action === 'deactivated'
            ) {
                changeUserStatus(values)
                console.log(values, 'EmpValues')
                setReload(!reload)
                setEmpStatusModal(false)
            }
        },
    })

    useEffect(() => {
        if (
            (data?.status == 'new' || props.employeeStatus == 'new') &&
            props.autoenable
        ) {
            if (formik.values.emp_type === 'super_admin') {
                formik.setFieldValue(
                    'emp_permissions',
                    props.super_admin_permission
                )
            } else if (formik.values.emp_type === 'admin') {
                formik.setFieldValue('emp_permissions', props.admin_permission)
            } else {
                formik.setFieldValue('emp_permissions', [])
            }
            //    super_admin_permission = { super_admin_permission }
            //    admin_permission = { admin_permission }
        }
    }, [formik.values.emp_type])

    const statusData = {
        formik: formikStatus,
        data: [
            {
                label: `${props.type || 'Employee'} status`,
                placeholder: `Select ${props.type || 'employee'} status`,
                type: 'select',
                class: 'col-12',
                options: [
                    { value: 'active', show: 'Active' },
                    {
                        value: `${
                            props.deactivated ? 'deactivated' : 'deactivate'
                        }`,
                        show: 'Deactivated',
                    },
                ],
                name: 'action',
            },
        ],
    }

    useEffect(() => {
        setIsLoading(false)
    }, [data])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [props])
    useEffect(() => {
        if (data?.status === 'edit') {
            setIsLoading(true)
            formik.values.id = data.id
            formikPassword.values.id = data.id
            getSingleEmployee(formik.values)
        } else if (props.employeeId) {
            setIsLoading(true)
            formik.values.id = props.employeeId
            formikPassword.values.id = props.employeeId
            getSingleEmployee(formik.values)
        } else {
            props.resetFrom()
            setIsLoading(false)
        }
    }, [data?.id, props?.employeeId, reload])

    useEffect(() => {
        if (
            formik.values.select_all &&
            formik.values?.select_all.includes('/all') &&
            props.permissionSelect
        ) {
            formik.values.emp_permissions = props.permissionSelect
        } else if (
            formik.values.select_all &&
            formik.values?.select_all.includes('/profile1') &&
            props.profile1
        ) {
            formik.values.emp_permissions = props.profile1
        } else if (
            formik.values.select_all &&
            formik.values?.select_all.includes('/profile2') &&
            props.profile2
        ) {
            formik.values.emp_permissions = props.profile2
        } else if (
            formik.values.select_all &&
            formik.values?.select_all.includes('/profile3') &&
            props.profile3
        ) {
            formik.values.emp_permissions = props.profile3
        } else if (
            formik.values.select_all &&
            (formik.values?.select_all.length == 0 ||
                formik.values?.select_all == '/none') &&
            props.permissionSelect
        ) {
            formik.values.emp_permissions = []
        }
    }, [formik.values?.select_all, props.permissionSelect])
    useEffect(() => {
        if (responseStatusEmployee) {
            if (responseStatusEmployee.status === 'success') {
                if (responseStatusEmployee.from === 'employeeAction') {
                    getSingleEmployee(formik.values)
                    formik.resetForm()
                    if (props.resetFrom) {
                        props.resetFrom()
                    }
                    if (props.noFullScreen) {
                        setEmpModal(false)
                        setPasswordStatus(false)
                    } else if (props?.closeFunction) {
                        props.closeFunction()
                    }
                    formikPassword.resetForm()
                } else if (responseStatusEmployee.from === 'changeStatus') {
                    getSingleEmployee(formik.values)
                }
            }
            formik.setSubmitting(false)
            setIsLoading(false)
            formik.resetForm()
        }
    }, [responseStatusEmployee])
    useEffect(() => {
        if (props.employeeFunctionEdit) {
            props.employeeFunctionEdit(single_employee)
        }
    }, [single_employee])

    useEffect(() => {
        props.formikValueUpdate(formik.values)
    }, [formik.values])

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
        formikPassword.resetForm()
    }

    const notificationClose = () => {
        getSingleEmployee(formik.values)
        setEmpPermission(false)
        setIsLoading(true)
    }

    // useEffect(() => {
    //     if (data.popup) {
    //         setValue(0)
    //     }
    // }, [data.popup])

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const closeFunction = () => {
        props.toggleFullScreenPopup(false)
        props.resetFrom()
    }

    useEffect(() => {
        if (single_employee) {
            formikStatus.values.action = single_employee.record.emp_status
            formikStatus.values.user_id = [single_employee.record.id]
        }
    }, [single_employee])
    return props.noFullScreen ? (
        <>
            <div className="addUserModal">
                <div className="">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="buyerDetailsTab">
                            <div className="bdTop">
                                <div className="bdUser">
                                    <h2>
                                        <span className="material-icons">
                                            account_circle
                                        </span>
                                        {single_employee?.record?.emp_firstname}{' '}
                                        {single_employee?.record?.emp_lastname}
                                    </h2>
                                    {single_employee?.record?.emp_status ===
                                    'active' ? (
                                        <h6>
                                            <span className="material-icons active">
                                                check_circle
                                            </span>
                                            Active
                                        </h6>
                                    ) : single_employee?.record?.emp_status ===
                                          'deactivate' ||
                                      single_employee?.record?.emp_status ===
                                          'deactivated' ? (
                                        <h6>
                                            <span className="material-icons deactivated">
                                                do_disturb_alt
                                            </span>
                                            Deactivated
                                        </h6>
                                    ) : (
                                        <h6>
                                            <span className="material-icons cancelled">
                                                cancel
                                            </span>
                                            Rejected
                                        </h6>
                                    )}
                                </div>
                                <div>
                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handleMenuClick}
                                        variant="outlined"
                                    >
                                        <span className="material-icons edit">
                                            edit
                                        </span>
                                        Edit
                                        <span className="material-icons down">
                                            expand_more
                                        </span>
                                    </Button>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                setEmpModal(true)
                                                getSingleEmployee(formik.values)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            {props.type || 'Employee'} Details
                                        </MenuItem>

                                        <MenuItem
                                            onClick={() => {
                                                setEmpStatusModal(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            {props.type || 'Employee'} Status
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setEmpPermission(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            {`${props.type || 'Employee'}`}{' '}
                                            Permissions
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setPasswordStatus(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            Change Password
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </div>
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label={`${
                                            props.type || 'Employee'
                                        } details`}
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    {/* <Tab
                                        label="Employee Permissions"
                                        value={1}
                                        onClick={() => handleChange(1)}
                                    /> */}

                                    {/* <Tab
                                        label="Change Password"
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel
                                className="bdInner"
                                value={value}
                                index={0}
                            >
                                <>
                                    <div className="userInfoSection">
                                        <div className="uiLt">
                                            <h3>{`${
                                                props.type || 'Employee'
                                            } profile`}</h3>
                                            <h4>
                                                <span>Name</span>
                                                {
                                                    single_employee?.record
                                                        ?.emp_firstname
                                                }{' '}
                                                {
                                                    single_employee?.record
                                                        ?.emp_lastname
                                                }
                                            </h4>
                                            <h4>
                                                <span>Email</span>
                                                {
                                                    single_employee?.record
                                                        ?.emp_email
                                                }{' '}
                                            </h4>
                                            <h4>
                                                <span>Phone</span>
                                                {
                                                    single_employee?.record
                                                        ?.emp_phone
                                                }
                                            </h4>
                                            <h4>
                                                <span>
                                                    {`${
                                                        props.type || 'Employee'
                                                    }`}{' '}
                                                    Type
                                                </span>
                                                {single_employee?.record
                                                    ?.emp_type == 'super_admin'
                                                    ? 'Super Admin'
                                                    : capitalize(
                                                          single_employee
                                                              ?.record?.emp_type
                                                      )}{' '}
                                            </h4>
                                            <h4>
                                                <span>Address</span>
                                                {(single_employee?.record
                                                    ?.emp_address1
                                                    ? `${single_employee?.record?.emp_address1}, `
                                                    : '') +
                                                    (single_employee?.record
                                                        ?.emp_city
                                                        ? `${single_employee?.record?.emp_city}, `
                                                        : '') +
                                                    (single_employee?.record
                                                        ?.emp_state
                                                        ? `${single_employee?.record?.emp_state}, `
                                                        : '') +
                                                    (single_employee?.record
                                                        ?.emp_country
                                                        ? `${single_employee?.record?.emp_country}, `
                                                        : '') +
                                                    (single_employee?.record
                                                        ?.emp_zip
                                                        ? `${single_employee?.record?.emp_zip}`
                                                        : '')}
                                            </h4>
                                            {single_employee?.record
                                                ?.emp_status ==
                                            'deactivated' ? (
                                                <h4>
                                                    <span>
                                                        Deactivated Date
                                                    </span>
                                                    {single_employee?.record
                                                        ?.deactivate_date
                                                        ? dateTimeFormatFunction(
                                                              single_employee
                                                                  ?.record
                                                                  ?.deactivate_date
                                                          )
                                                        : ''}{' '}
                                                </h4>
                                            ) : null}
                                        </div>
                                        <div className="uiRt">
                                            <h3>
                                                {`${props.type || 'Employee'}`}{' '}
                                                Permissions
                                            </h3>

                                            <EmpPermission
                                                data={single_employee?.record}
                                                // cancelFunction={cancelSubmit}
                                                readOnly={true}
                                                formik={formik}
                                                validationArray={
                                                    props.validationArray
                                                }
                                                dynamicPermission={
                                                    props.dynamicPermission
                                                }
                                                permissionDetails={
                                                    props.permissionDetails
                                                }
                                            />
                                        </div>
                                    </div>
                                </>
                            </TabPanel>

                            <TabPanel
                                className="bdInner"
                                value={value}
                                index={1}
                            >
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    {mapData({
                                        formik: formik,
                                        data: props.permissionDetails,
                                    })}
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <PrimaryButton
                                            id="employee_submit"
                                            type="submit"
                                            label="Submit"
                                        />
                                    </div>
                                </form>
                            </TabPanel>

                            <TabPanel
                                className="bdInner"
                                value={value}
                                index={2}
                            >
                                <form
                                    onSubmit={formikPassword.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <div className="row">
                                        {mapData({
                                            formik: formikPassword,
                                            data: props.passwordChange,
                                        })}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <SecondaryButton
                                            id="employee_cancel"
                                            label="Cancel"
                                            onClick={() =>
                                                props.closeFunction()
                                            }
                                        />

                                        <PrimaryButton
                                            id="employee_submit"
                                            type="submit"
                                            label="Submit"
                                        />
                                    </div>
                                </form>
                            </TabPanel>
                        </div>
                    )}
                </div>
            </div>

            <CustomDialog
                title={`${props.type || 'Employee'} details`}
                className="empModal"
                open={empModal}
                function={() => setEmpModal(false)}
            >
                <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                    <div className="row">
                        {mapData({
                            formik: formik,
                            data: props.personalDetailsNew,
                        })}
                    </div>
                    <div className="row">
                        {mapData({
                            formik: formik,
                            data: props.locationDetails,
                        })}
                    </div>

                    <div className="actionButton d-flex justify-content-end align-items-center flex-wrap">
                        <SecondaryButton
                            label="Cancel"
                            onClick={() => setEmpModal(false)}
                        />
                        <PrimaryButton
                            id="employee_submit"
                            btnSize="ml-2"
                            type="submit"
                            label="Submit"
                        />
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title={`Edit ${props.type || 'Employee'} status`}
                open={empStatusModal}
                function={() => setEmpStatusModal(false)}
                className="empStatusModal"
            >
                <form onSubmit={formikStatus.handleSubmit}>
                    <div className="row">{mapData(statusData)}</div>
                    <div className="actionButton d-flex align-items-center justify-content-end mt-4">
                        <SecondaryButton
                            label="Cancel"
                            onClick={() => setEmpStatusModal(false)}
                        />
                        <PrimaryButton
                            btnSize="ml-2"
                            label="Submit"
                            type="submit"
                        />
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title="Change Password"
                open={passwordStatus}
                function={() => setPasswordStatus(false)}
                className="empStatusModal"
            >
                <form
                    onSubmit={formikPassword.handleSubmit}
                    autoComplete="nofill"
                >
                    <div className="row">
                        {mapData({
                            formik: formikPassword,
                            data: props.passwordChange,
                        })}
                    </div>
                    <div className="actionButton d-flex align-items-center justify-content-end mt-4">
                        <SecondaryButton
                            id="employee_cancel"
                            label="Cancel"
                            onClick={() => setPasswordStatus(false)}
                        />

                        <PrimaryButton
                            id="employee_submit"
                            btnSize="ml-2"
                            type="submit"
                            label="Submit"
                        />
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title={`Edit ${props.type || 'Employee'} Permissions`}
                open={empPermission}
                function={() => setEmpPermission(false)}
                className="notifModal empPermCnt"
            >
                <EmpPermission
                    data={single_employee?.record}
                    formik={formik}
                    cancelFunction={notificationClose}
                    validationArray={props.validationArray}
                    dynamicPermission={props.dynamicPermission}
                    permissionDetails={props.permissionDetails}
                    selectDetails={props.selectDetails}
                />
            </CustomDialog>
        </>
    ) : props.isnotCustom ? (
        <Layout>
            <div className="addUserModal page">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <h2 className="dashTitle">
                                    {t('PERSONAL DETAILS')}
                                </h2>
                                <div className="row">
                                    {mapData({
                                        formik: formik,
                                        data: props.personalDetailsNew,
                                    })}
                                </div>
                                <h2 className="dashTitle">
                                    {t('LOCATION DETAILS')}
                                </h2>
                                <div className="row">
                                    {mapData({
                                        formik: formik,
                                        data: props.locationDetails,
                                    })}
                                </div>

                                <h2 className="dashTitle">
                                    {t('PERMISSIONS')}
                                </h2>
                                {props.selectDetails
                                    ? mapData({
                                          formik: formik,
                                          data: props.selectDetails,
                                      })
                                    : null}
                                {mapData({
                                    formik: formik,
                                    data: props.permissionDetails,
                                })}
                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <PrimaryButton
                                        id="employee_submit"
                                        type="submit"
                                        label={t('Submit')}
                                    />
                                </div>
                            </form>
                            {props?.employeeStatus == 'edit' ? (
                                <form
                                    onSubmit={formikPassword.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <h2 className="dashTitle">
                                        {t('Reset Password')}
                                    </h2>
                                    <div className="row">
                                        {mapData({
                                            formik: formikPassword,
                                            data: props.passwordChange,
                                        })}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <SecondaryButton
                                            id="employee_cancel"
                                            label={t('Cancel')}
                                            onClick={() =>
                                                props.closeFunction()
                                            }
                                        />
                                        <PrimaryButton
                                            id="employee_submit"
                                            type="submit"
                                            label={t('Submit')}
                                        />
                                    </div>
                                </form>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </Layout>
    ) : (
        <>
            <FullScreenPopup
                modaltitle={
                    data.status === 'new'
                        ? t('ADD NEW EMPLOYEE')
                        : `EDIT EMPLOYEE: ${single_employee.record.emp_firstname} ${single_employee.record.emp_lastname}`
                }
                open={data.popup}
                handleClose={() => closeFunction()}
            >
                <div className="addUserModal">
                    <div className="fspBody">
                        {formik.isSubmitting ? <LinearProgress /> : null}
                        {isLoading ? (
                            <div className="fspLoader">
                                <Loaders isLoading={isLoading} />
                            </div>
                        ) : (
                            <>
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <h2 className="dashTitle">
                                        {t('PERSONAL DETAILS')}
                                    </h2>
                                    <div className="row">
                                        {mapData({
                                            formik: formik,
                                            data: props.personalDetailsNew,
                                        })}
                                    </div>
                                    <h2 className="dashTitle">
                                        {t('LOCATION DETAILS')}
                                    </h2>
                                    <div className="row">
                                        {mapData({
                                            formik: formik,
                                            data: props.locationDetails,
                                        })}
                                    </div>

                                    <h2 className="dashTitle">
                                        {t('PERMISSIONS')}
                                    </h2>
                                    {mapData({
                                        formik: formik,
                                        data: props.permissionDetails,
                                    })}
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <PrimaryButton
                                            id="employee_submit"
                                            type="submit"
                                            label={t('Submit')}
                                        />
                                    </div>
                                </form>
                                {data.status === 'edit' ? (
                                    <form
                                        onSubmit={formikPassword.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <h2 className="dashTitle">
                                            {t('Reset Password')}
                                        </h2>
                                        <div className="row">
                                            {mapData({
                                                formik: formikPassword,
                                                data: props.passwordChange,
                                            })}
                                        </div>
                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <SecondaryButton
                                                id="employee_cancel"
                                                label={t('Cancel')}
                                                onClick={() => closeFunction()}
                                            />
                                            <PrimaryButton
                                                id="employee_submit"
                                                type="submit"
                                                label={t('Submit')}
                                            />
                                        </div>
                                    </form>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </FullScreenPopup>
        </>
    )
}

export default EmployeeForm
